import {
  DataTableTableViewMode,
  FormDefaultAttributes,
  type DataTableItem,
  type FormConfig,
  type PartialDataTableConfig,
  type TextConfig
} from '@common';
import { HeightmapDataExtraInfoAction, HeightmapDataTableStatusCell } from '../components';
import { markRaw } from 'vue';
import type { ParcelHeightmapItem } from '../models';

export const HEIGHT_MAP_TABLE_CONFIG: PartialDataTableConfig = {
  needTableHeader: true,
  showViewModes: false,
  fixedHeader: true,
  showIndexColumn: false,
  viewModes: [
    {
      name: 'table',
      label: 'dataTable.viewMode.table',
      icon: 'mdi-view-list',
      translateLabel: true,
      showSortSelect: false,
      showColumnSelect: true,
      component: DataTableTableViewMode as any,
      componentConfig: {}
    }
  ],
  clickableItems: true,
  height: '100%',
  hover: true,
  columns: [
    {
      name: 'name',
      label: 'heightmap.label.name',
      translateLabel: true
    },
    {
      name: 'area',
      label: 'heightmap.label.area',
      translateLabel: true,
      cellConfig: {
        emptyValue: '-',
        postfix: ' ha'
      }
    },
    {
      name: 'coverage',
      label: 'heightmap.label.coverage',
      translateLabel: true,
      cellComponent: markRaw(HeightmapDataTableStatusCell)
    }
  ],
  actions: {
    global: [],
    row: [
      {
        action: 'extraData',
        actionComponent: markRaw(HeightmapDataExtraInfoAction)
      },
      {
        action: 'click',
        actionConfig: {
          label: 'button.heightmapModuleOrdered',
          translateLabel: true,
          icon: 'mdi-image-filter-hdr-outline',
          size: 'small',
          variant: 'flat'
        },
        condition: (item: DataTableItem<ParcelHeightmapItem>) => item.data.layerGroup12 !== null
      },
      {
        action: 'delete',
        actionConfig: {
          label: 'button.delete',
          translateLabel: true,
          icon: 'mdi-delete',
          size: 'small',
          variant: 'flat',
          iconColor: 'error'
        },
        condition: (item: DataTableItem<ParcelHeightmapItem>) => item.data.canDelete
      }
    ]
  }
};

export const HEIGHT_MAP_FILTER_FORM_CONFIG: FormConfig = {
  name: 'heightmapTableFiltersForm',
  attributes: {
    ...FormDefaultAttributes.getFormDefaultAttributes(),
    class: 'flex-grow-1 z-5'
  },
  settings: {},
  children: [
    {
      name: 'searchText',
      component: 'text',
      attributes: {
        type: 'text',
        label: 'filter.search',
        hideDetails: true
      },
      settings: {
        grid: { cols: 12, md: 12 },
        needTranslate: true
      }
    } as TextConfig
  ]
};
